import deparameterize from './deparameterize';
import capitalize from './capitalize';

/**
 * Create location into parts
 * {
 *   suburb,
 *   state,
 *   postcode
 * }
 */

export default function deconstructLocation(address) {
  const parts = {
    suburb: '',
    state: '',
    postcode: '',
  };
  let location = address;
  let matches;
  let suburb;
  let state;
  let postcode;

  if (typeof location === 'string' || location instanceof String) {
    location = decodeURIComponent(location)
      .replace(/[^0-9a-z]/gi, ' ')
      .replace(/[,\s]+|[,\s]+/g, ' ')
      .trim();
    suburb = location;

    // Get postcode
    if (location.match(/(\d{4})$/g) !== null) {
      matches = location.match(/(\d{4})$/g);
      // Match postcode
      [postcode] = matches;
      location = location.replace(/[0-9]/g, '').trim();
      suburb = location;
    }

    // Get state
    if (location.match(/(QLD|NT|NSW|VIC|SA|ACT|WA)/g) !== null) {
      matches = location.match(/(QLD|NT|NSW|VIC|SA|ACT|WA)/g);
      [state] = matches;
      location = location.replace(/(QLD|NT|NSW|VIC|SA|ACT|WA)/g, '').trim();
      suburb = location;
    } else if (location.match(/(QLD|NT|NSW|VIC|SA|ACT|WA)$/gi) !== null) {
      matches = location.match(/(QLD|NT|NSW|VIC|SA|ACT|WA)$/gi);
      [state] = matches;
      location = location.replace(/(QLD|NT|NSW|VIC|SA|ACT|WA)$/gi, '').trim();
      suburb = location;
    }
  }
  if (suburb) {
    parts.suburb = capitalize(
      deparameterize(suburb.replace(/region|online/gi, ''))
    ).trim();
    parts.location = parts.suburb;
  }
  if (state) {
    parts.state = state.toUpperCase().trim();
    parts.location += `, ${parts.state}`;
  }
  if (postcode) {
    parts.postcode = postcode.trim();
    parts.location += ` ${parts.postcode}`;
  }

  return parts;
}
